import api from '../common/helpers/apiHelper';
import { IQuestionForReference } from '../common/models/question/IQuestionForReference';
import { IFetchRefQuestions } from '../common/models/question/IFetchRefQuestions';
import { ISaveRefQuestion } from '../common/models/question/ISaveRefQuestion';
import { getCode, key } from '../common/helpers/common';

export const fetchQuestions = (payload: IFetchRefQuestions) => (
  api.get<IQuestionForReference[]>('/reference-api/questions', { ...payload, key, code: getCode() })
);

export const fetchQuestionsForManualInput = ({ referenceId, ...payload }: IFetchRefQuestions) => (
  api.get<IQuestionForReference[]>(`/api/references/${referenceId}/questions`, payload)
);

export const saveAnswer = (question: ISaveRefQuestion) => api.post(
  `/reference-api/answer?key=${key}&code=${getCode()}`, question
);

export const saveManualInputAnswer = ({ referenceId, ...question }: ISaveRefQuestion) => api.post(
  `/api/references/${referenceId}/answer`, question
);
